import React from "react";
import { Badge } from "antd";

export const StatusRender = props => {
  const {
    qtyAvail,
    available,
    catType,
    qtyOnHire,
    conditions,
    condition,
    terminated,
    reserved
  } = props;

  let color = conditions.find(c => c.condition === condition);
  if (!color) {
    color.colorHex = "white";
    color.condition = "";
  }
  // Equipment sometimes comes with multiple status, they can be reserved out
  // and in at the same time
  // with this first switch we validate against the status selected on the form.
  if (catType === "SERIAL") {
    switch (true) {
      case reserved >= qtyAvail:
        return (
          <Badge
            color={color.colorHex}
            text={`Reserved (${color.condition})`}
          />
        );
      case terminated >= qtyAvail:
        return (
          <Badge
            color={color.condition === "Ready" ? "white" : color.colorHex}
            text={`Terminated ${
              color.condition === "Ready" ? "" : `(${color.condition})`
            }`}
          />
        );
      case qtyAvail === qtyOnHire:
        return (
          <Badge
            color={color.condition === "Ready" ? "white" : color.colorHex}
            text={`Out ${
              color.condition === "Ready" ? "" : `(${color.condition})`
            }`}
          />
        );
      case available > 0:
        return (
          <Badge color={color.colorHex} text={`In (${color.condition})`} />
        );
      default:
        return (
          <div>
            <Badge color="red" text="Unknown" />
          </div>
        );
    }
  }
  return (
    <div className="statusBulk">
      <label>Qty: {qtyAvail} </label>
      <label>Out: {qtyOnHire} </label>
      <label>In: {available} </label>
      <label>Rsvd: {reserved || 0} </label>
      <label>Term: {terminated || 0} </label>
    </div>
  );
};
